import type { ResponseType } from "@cttq/cttq-request";
import { BaseRequestInstance } from "./base";
export interface MaterialTableRequest {
  type?: string; 
  pageNum?: number; 
  pageSize?: number; 
  keyWord?: string; 
}

export interface MaterialTableResponse<T = any> {
        msgCode: string;
        message: string;
        sysMessage: string;
        responseData: {
        records: Array<{
            englishName: string;
            chineseName: string;
            casNumber: string;
            }>;
            total: number;
            pageNum: number;
            pageSize: number;
            hasMore: boolean;
        };
        ext: Record<string, any>;
        iTotalRecords: number;
        iTotalDisplayRecords: number;
        traceId: string;
}

export const getMaterialTableData = (data: MaterialTableRequest) => {
	return BaseRequestInstance.post<ResponseType<MaterialTableResponse>>({
		url: "/feishu/material-table/reference-items",
		data
	});
};

// 分页查询生物药列表
export const getBioDrugsTableData = (data: MaterialTableRequest) => {
	return BaseRequestInstance.post<ResponseType<MaterialTableResponse>>({
		url: "/feishu/material-table/bio-drugs",
		data
	});
};

// 分页查询生物药中间体列表
export const getBioDrugsIntermediatesTableData = (data: MaterialTableRequest) => {
	return BaseRequestInstance.post<ResponseType<MaterialTableResponse>>({
		url: "/feishu/material-table/bio-drug-intermediates",
		data
	});
};

// 分页查询生物催化酶列表
export const getBioCatalyticEnzymesTableData = (data: MaterialTableRequest) => {
	return BaseRequestInstance.post<ResponseType<MaterialTableResponse>>({
		url: "/feishu/material-table/bio-catalytic-enzymes",
		data
	});
};

export interface ActiveTableResponse<T = any> {
        msgCode: string;
        message: string;
        sysMessage: string;
        responseData: {
        records: Array<{
            englishName: string;
            chineseName: string;
            casNumber: string;
            productPicture: string;
            productCharacteristics: string;
            productStatus: string;
            qualityStandard: string;
            }>;
            total: number;
            pageNum: number;
            pageSize: number;
            hasMore: boolean;
        };
        ext: Record<string, any>;
        iTotalRecords: number;
        iTotalDisplayRecords: number;
        traceId: string;
    }

export const getActiveTableData = (data: MaterialTableRequest) => {
	return BaseRequestInstance.post<ResponseType<ActiveTableResponse>>({
		url: "/feishu/material-table/material",
		data
	});
};
